import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumComponent } from '../breadcrum/breadcrum.component';

@Component({
  selector: 'app-terms-condition',
  standalone: true,
  imports: [CommonModule, BreadcrumComponent],
  templateUrl: './terms-condition.component.html',
  styleUrl: './terms-condition.component.scss',
})
export class TermsConditionComponent implements OnInit {
  activeSection: string = 'intro';

  // Breadcrumb data
  breadcrumbData = [{ label: 'Buyer Terms & Conditions', url: null }];

  // Array to track which sections are open in mobile view
  openSections: { [key: string]: boolean } = {
    intro: true,
    definitions: false,
    eligibility: false,
    services: false,
    account: false,
    ip: false,
    responsibility: false,
    returns: false,
    payments: false,
    termination: false,
    disclaimers: false,
    indemnity: false,
    liability: false,
    jurisdiction: false,
    miscellaneous: false,
  };

  @ViewChild('introSection') introSection!: ElementRef;
  @ViewChild('definitionsSection') definitionsSection!: ElementRef;
  @ViewChild('eligibilitySection') eligibilitySection!: ElementRef;
  @ViewChild('servicesSection') servicesSection!: ElementRef;
  @ViewChild('accountSection') accountSection!: ElementRef;
  @ViewChild('ipSection') ipSection!: ElementRef;
  @ViewChild('responsibilitySection') responsibilitySection!: ElementRef;
  @ViewChild('returnsSection') returnsSection!: ElementRef;
  @ViewChild('paymentsSection') paymentsSection!: ElementRef;
  @ViewChild('terminationSection') terminationSection!: ElementRef;
  @ViewChild('disclaimersSection') disclaimersSection!: ElementRef;
  @ViewChild('indemnitySection') indemnitySection!: ElementRef;
  @ViewChild('liabilitySection') liabilitySection!: ElementRef;
  @ViewChild('jurisdictionSection') jurisdictionSection!: ElementRef;
  @ViewChild('miscellaneousSection') miscellaneousSection!: ElementRef;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    // Check for query parameters to set active section
    this.route.queryParams.subscribe((params) => {
      if (params['tab']) {
        const tab = params['tab'];
        this.activeSection = tab;
        // For mobile view, open the specified section
        this.openSections = {};
        this.openSections[tab] = true;

        // Scroll to the section after a short delay to ensure DOM is ready
        setTimeout(() => {
          this.scrollToSection(tab);
        }, 100);
      }
    });
  }

  // Toggle section visibility in mobile view
  toggleSection(section: string) {
    this.openSections[section] = !this.openSections[section];
  }

  // Check if section is open
  isSectionOpen(section: string): boolean {
    return !!this.openSections[section];
  }

  scrollToSection(section: string) {
    this.activeSection = section;
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  // Track active section as user scrolls through the right content
  onContentScroll(event: Event) {
    const container = event.target as HTMLElement;
    if (!container) return;

    const sections = [
      'intro',
      'definitions',
      'eligibility',
      'services',
      'account',
      'ip',
      'responsibility',
      'returns',
      'payments',
      'termination',
      'disclaimers',
      'indemnity',
      'liability',
      'jurisdiction',
      'miscellaneous',
    ];

    const containerTop = container.getBoundingClientRect().top;

    for (const sectionId of sections) {
      const el = document.getElementById(sectionId);
      if (el) {
        const rect = el.getBoundingClientRect();
        // Check if the section is currently near the top of the container
        if (rect.top - containerTop <= 100 && rect.bottom - containerTop > 40) {
          this.activeSection = sectionId;
          break;
        }
      }
    }
  }
}

